<ng-container >
    <img width="250" src="/assets/img/{{title}}.svg" alt="Image" />
</ng-container>
